import { logger } from 'utils/logger';
import { ConfigContext } from "App";
import { OrderData, OutcomeData } from "common/data_interfaces";
import BreadCrumb from "Components/Common/Shared/BreadCrumb";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Card, CardBody, CardHeader, Container, Modal, ModalBody, ModalHeader } from "reactstrap";
import AlertMessage from "Components/Common/Shared/AlertMesagge";
import LoadingGif from '../../assets/images/loading-gif.gif'
import ErrorModal from "Components/Common/Shared/ErrorModal";
import SuccessModal from "Components/Common/Shared/SuccessModal";
import CompleteOrderForm from "Components/Common/Forms/CompleteOrderForm";
import PDFViewer from "Components/Common/Shared/PDFViewer";
import { useTranslation } from "react-i18next";

const CompleteOrder = () => {
    const { t } = useTranslation();
    const history = useNavigate();
    const { id_order } = useParams();
    const configContext = useContext(ConfigContext)
    const [ordersDetails, setOrderDetails] = useState<OrderData>()
    const [loading, setLoading] = useState<boolean>(true)
    const [modals, setModals] = useState({ success: false, error: false, viewPDF: false });
    const [fileURL, setFileURL] = useState<string>('')
    const [alertConfig, setAlertConfig] = useState({ visible: false, color: '', message: '' })

    const handleError = (error: any, message: string) => {
        logger.error(message, error)
        setAlertConfig({ visible: true, color: 'danger', message: message })
        setTimeout(() => {
            setAlertConfig({ ...alertConfig, visible: false })
        }, 5000);
    }

    const toggleModal = (modalName: keyof typeof modals, state?: boolean) => {
        setModals((prev) => ({ ...prev, [modalName]: state ?? !prev[modalName] }));
    };

    const fetchOrderDetails = async () => {
        if (!configContext) return;

        try {
            const response = await configContext.axiosHelper.get(`${configContext.apiUrl}/orders/find_id/${id_order}`);
            setOrderDetails(response.data.data);
        } catch (error) {
            logger.error(error, 'Ha ocurrido un error obteniendo la información del pedido')
            toggleModal('error')
        } finally {
            setLoading(false)
        }
    };

    const handleCompleteOrder = async (data: OrderData) => {
        if (!configContext) return;
        try {
            data.status = 'completed';
            await configContext.axiosHelper.put(`${configContext.apiUrl}/orders/update_order/${data.id}`, data);

            await createOutcome(data);
        } catch (error) {
            toggleModal('error')
        }
    };


    const createOutcome = async (data: OrderData) => {
        if (!configContext) return;

        try {
            let lastOutcomeId = '';
            const response = await configContext.axiosHelper.get(`${configContext.apiUrl}/outcomes/outcome_next_id`);
            lastOutcomeId = response.data.data;

            const outcomeData: OutcomeData = {
                code: lastOutcomeId,
                date: data.date,
                products: data.productsDelivered,
                outcomeType: "order",
                status: true,
                warehouseDestiny: data.orderDestiny,
                warehouseOrigin: data.orderOrigin,
                totalPrice: 0,
                description: 'N/A'
            };

            await configContext.axiosHelper.create(`${configContext.apiUrl}/outcomes/create_outcome/true/order`, outcomeData);
            toggleModal('success')

        } catch (error) {
            throw error
        }
    };

    const handlePrintOrder = async () => {
        if (!configContext) return;

        try {

            const response = await configContext.axiosHelper.get(
                `${configContext.apiUrl}/reports/generate_order_report/${id_order}`,
                { responseType: 'blob' }
            );

            const url = window.URL.createObjectURL(new Blob([response.data]));
            setFileURL(url);
            toggleModal('viewPDF')
        } catch (error) {
            handleError(error, 'Ha ocurrido un error al generar el reporte, inténtelo más tarde.');
        }
    };


    const handleCancel = () => {
        history('/orders/send_orders')
    }


    useEffect(() => {
        fetchOrderDetails();
    }, [])


    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100 page-content">
                <img src={LoadingGif} alt="Cargando..." style={{ width: "200px" }} />
            </div>
        );
    }


    return (
        <div className="page-content">
            <Container fluid>
                <BreadCrumb title={t('warehouse.orders.modal.complete', { defaultValue: 'Completar Pedido' })} pageTitle={t('warehouse.orders.breadcrumb.parent', { defaultValue: 'Pedidos' })} />

                <Card>
                    <CardHeader>
                        <div className="d-flex gap-2">
                            <h5>{t('warehouse.orders.modal.details', { defaultValue: 'Detalles del Pedido' })}</h5>

                            <Button className="ms-auto farm-primary-button" onClick={handlePrintOrder}>
                                <i className="ri-download-line me-2"></i>
                                {t('warehouse.orderDetails.button.report', { defaultValue: 'Descargar Reporte' })}
                            </Button>
                        </div>
                    </CardHeader>
                    <CardBody>
                    </CardBody>
                </Card>

            </Container>


            <SuccessModal isOpen={modals.success} onClose={handleCancel} message={t('warehouse.orders.success.complete', { defaultValue: 'El pedido se ha completado exitosamente' })}></SuccessModal>
            <ErrorModal isOpen={modals.error} onClose={handleCancel} message={t('warehouse.orders.error.complete', { defaultValue: 'Ha ocurrido un error al completar el pedido, intentelo mas tarde' })}></ErrorModal>

            <Modal size="xl" isOpen={modals.viewPDF} toggle={() => toggleModal("viewPDF")} backdrop='static' keyboard={false} centered fullscreen={true}>
                <ModalHeader toggle={() => toggleModal("viewPDF")}>{t('warehouse.orderDetails.modal.report', { defaultValue: 'Reporte de Pedido' })}</ModalHeader>
                <ModalBody>
                    {fileURL && <PDFViewer fileUrl={fileURL} />}
                </ModalBody>
            </Modal>

            <AlertMessage color={alertConfig.color} message={alertConfig.message} visible={alertConfig.visible} onClose={() => setAlertConfig({ ...alertConfig, visible: false })} />
        </div>
    )
}

export default CompleteOrder;
